export default {
  "content": "<path fill=\"currentColor\" d=\"M12.204 19.08c.523 0 .946-.433.946-.922V12.96h5.064a.95.95 0 00.938-.946.955.955 0 00-.938-.946H13.15V5.873c0-.498-.423-.922-.946-.922-.515 0-.946.424-.946.922v5.196H6.194a.966.966 0 00-.938.946.96.96 0 00.938.946h5.064v5.197c0 .49.431.921.946.921z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  }
};